import {
	Step,
	StepType,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { GetKYCInvestorInstanceRes, KycEventLogEntity } from '@dealstack/shared/lib/generated';
import { SelectedTemplate } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/types';

export const selectKycStepHistory = (
	currentStep: Step,
	currentInvestor: GetKYCInvestorInstanceRes | undefined,
	selectedTemplate?: SelectedTemplate
): KycEventLogEntity[] | undefined => {
	const kycHistory = currentInvestor?.kycHistory;
	switch (currentStep?.type) {
		case StepType.DECLARATIONS: {
			const events =
				currentInvestor?.declarations
					?.filter((declaration) => declaration.checked === true)
					.flatMap((declaration) => declaration.kycEventLog ?? []) ?? [];
			return events.sort(
				(a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
			);
		}

		case StepType.PROOF_OF_ADDRESS:
			return kycHistory?.PROOF_OF_ADDRESS;

		case StepType.PROOF_OF_IDENTITY:
			return kycHistory?.PROOF_OF_IDENTITY;

		case StepType.INVESTMENT_VEHICLE:
			return kycHistory?.INVESTMENT_VEHICLE;

		case StepType.FORM: {
			const formHistory = kycHistory?.FORM ?? [];
			if (selectedTemplate) {
				return formHistory.filter(
					(event) => event.templateId === selectedTemplate.templateId
				);
			}
			return formHistory;
		}

		default:
			return undefined;
	}
};
